import { createContext, useEffect, useMemo, type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/services/api'

const AuthContext = createContext<null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const { isAuthenticated, token, setUser, clearAuth } = useAuthStore()

  // expose a stable context value if needed in future
  const contextValue = useMemo(() => ({ isAuthenticated, token }), [isAuthenticated, token])

  useEffect(() => {
    if (!isAuthenticated && !token && window.location.pathname !== '/login') {
      navigate('/login')
    }
  }, [isAuthenticated, token, navigate])

  useEffect(() => {
    if (!token) return

    let cancelled = false
    void authApi.me()
      .then(response => {
        if (!cancelled) setUser(response.data)
      })
      .catch(() => {
        if (!cancelled) clearAuth()
      })

    return () => {
      cancelled = true
    }
  }, [token, setUser, clearAuth])

  return <AuthContext.Provider value={contextValue as any}>{children}</AuthContext.Provider>
}

export function useAuth() {
  return useAuthStore()
}
